<!-- Created this SFC as Vue doesn't allow inline <script> tags. -->
<!-- This will be replaced by the Form factory when we can use Hubspot's API. -->
<template>
  <div :class="`hubspot-form form form--${theme}-theme`">
    <div class="hubspot-form__form-embed" :id="`hf-${formId}`"></div>
  </div>
</template>

<script>
export default {
  name: 'HubspotForm',
  props: {
    formId: {
      type: String,
      required: true,
    },
    theme: {
      type: String, // e.g. either 'light' or 'dark'
      default: 'light',
    },
  },
  mounted() {
    // Fake jQuery for stupid HubSpot JS.
    // (We do have jQuery in Drupal but only when the user is logged in).
    // todo: get rid of this as soon as HubSpot API is available.
    window.jQuery ||= sel => typeof sel === 'string' ? document.querySelector(sel) : sel;
    window.addEventListener('UC_UI_CMP_EVENT', this.onConsentChange);
    this.checkAndLoadForm();
  },
  beforeUnmount() {
    window.removeEventListener('UC_UI_CMP_EVENT', this.onConsentChange);
    this.removeHubspotForm();
  },
  methods: {
    onConsentChange(event) {
      const relevantEvents = ['ACCEPT_ALL', 'DENY_ALL', 'SAVE'];
      if (relevantEvents.includes(event.detail.type)) {
        this.checkAndLoadForm();
      }
    },

    checkAndLoadForm() {
      const hubspotSvc = window.UC_UI?.getServicesBaseInfo()
        ?.find(s => s.name.includes('HubSpot'));

      this.loadHubspotForm(hubspotSvc?.consent?.status);
    },

    loadHubspotForm(remove = false) {
      if (remove) {
        // Clear existing form first
        this.removeHubspotForm();
      }
      
      const cfg = {
        region: 'eu1',
        portalId: '25488523',
        formId: this.formId,
        target: `#hf-${this.formId}`,
        onFormReady: this.addFormStyles,
      };

      if (window.hbspt) {
        hbspt.forms.create(cfg);
        return;
      }

      if (!this.scriptLoaded) {
        this.scriptLoaded = true;
        const script = document.createElement('script');
        script.src = 'https://js-eu1.hsforms.net/forms/v2.js';
        script.setAttribute('data-cookieconsent', 'ignore');
        script.onload = () => hbspt.forms.create(cfg);
        document.head.appendChild(script);
      }
    },

    removeHubspotForm() {
      const container = document.getElementById(`hf-${this.formId}`);
      if (container) {
        // Remove all form elements
        container.innerHTML = '';
      }
    },

    addFormStyles() {
      document
        .querySelectorAll('.hs-fieldtype-text .input, .hs-fieldtype-textarea .input')
        .forEach(el => {
          if (!el.querySelector('.animated-border')) {
            const span = document.createElement('span');
            span.className = 'animated-border';
            el.appendChild(span);
          }
        });
    },
  },
};
</script>
